import React, { useContext } from 'react';
import { ThemeContext } from '../context/ThemeContext';
import '../styles/theme-toggle.css';

const ThemeToggle = ({ additionalOnClick }) => {
  const { isDarkMode, toggleTheme } = useContext(ThemeContext);
  
  const handleClick = (e) => {
    // Stop propagation to prevent drawer from closing
    e.stopPropagation();
    
    // Toggle theme
    toggleTheme();
    
    // Call additional onClick function if provided
    if (additionalOnClick) {
      additionalOnClick(e);
    }
  };
  
  return (
    <button 
      className={`theme-toggle ${isDarkMode ? 'dark' : 'light'}`}
      onClick={handleClick}
    >
      {isDarkMode ? '☀️' : '🌙'}
    </button>
  );
};

export default ThemeToggle; 